<template>
  <div>
    <form
      name="form"
      @submit.prevent="handleCheckReset"
      class="form-horizontal"
      id="validate-form"
    >
      <div class="form-group mb-md">
        <div class="col-xs-12">
          <div class="input-group">
            <label for="username">Please Enter Email</label>
            <input
              class="form-control"
              v-model="username"
              :readonly="isUsernameReadononly"
              v-validate="'required'"
              name="userName"
            />
          </div>
          <div
            v-if="errors.has('userName')"
            class="alert alert-danger"
            role="alert"
          >
            details is required!
          </div>
        </div>
        <div class="col-xs-12" v-if="!isHidden">
          <div class="input-group">
            <label for="username">Please Enter Code</label>
            <input
              class="form-control"
              v-model="code"
              v-validate="'required'"
              name="code"
            />
            <div
              v-if="errors.has('code')"
              class="alert alert-danger"
              role="alert"
            >
              Code is required!
            </div>
          </div>
        </div>
      </div>
      <div class="panel-footer">
        <div class="clearfix">
          <button
            type="button"
            class="btn btn-sm btn-primary submitbtn btn-raised pull-left"
            @click="resendCode"
            v-if="!isHidden"
            :disabled="ViewCounter"
          >
            Resend Code {{ ViewCounter | cleanUpText }}
          </button>
          <button
            type="submit"
            class="btn btn-primary submitbtn btn-raised pull-right"
            :disabled="loading"
          >
            <span> {{ ButtonText }} </span>
          </button>
        </div>

        <div class="form-group">
          <div v-if="ErrorMessage" class="alert alert-danger" role="alert">
            {{ ErrorMessage }}
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import commonServices from '../../services/common-services';
import OpenAuth from '../../services/auth.service';
export default {
  name: 'takeEmail',
  data() {
    return {
      username: '',
      code: '',
      loading: false,
      isHidden: true,
      isUsernameReadononly: false,
      ErrorMessage: '',
      ButtonText: 'Submit',
      timerCount: 10,
    };
  },
  methods: {
    resendCode() {
      this.timerCount = 10;
      let data = {};
        data['username'] = this.username;
      OpenAuth.get('kspgAPI/commonData/resetPasswordCodeGenerate', data)
          .then((response) => {
            if (response.data.status) {
              this.loading = false;
              this.isHidden = false;
              this.isUsernameReadononly = true;
              this.ButtonText = 'Verify Code';
              this.timerCount = 10;
            }
          })
          .catch((e) => {
            if (e.response.data.error == 'Invalid API key ') {
              loader.hide();
              // this.$router.push({ name: 'login'});
            }
          });
    },
    handleCheckReset() {
      this.loading = true;
      this.$validator.validateAll().then((isValid) => {
        if (!isValid) {
          this.loading = false;
          return;
        }

        let data = {};
        data['username'] = this.username;
        if (this.code) {
          data['code'] = this.code;
          OpenAuth.put('kspgAPI/commonData/resetPasswordCodeVerify', data)
            .then((response) => {
              if (response.data.status) {
                /**Save Auth Code */
                const payload =  {token: response.data.token};
                localStorage.setItem('passwordReset',JSON.stringify(payload));
                console.log(payload);
                this.$router.push({ path: 'setNewPassword'});
              }
            })
            .catch((e) => {
              if (e.response.data.error == 'Invalid API key ') {
                loader.hide();
                // this.$router.push({ name: 'login'});
              }
              this.ErrorMessage = e.response.data.message;
            });
          return;
        }

        /**Send */
        this.resendCode();
      });
    },
  },
  filters: {
      cleanUpText (inPut){
          if(inPut) {
              return inPut;
          }
           return '';
      }
  },
  computed: {
    ViewCounter() {
      return this.timerCount > 0 ? this.timerCount : false;
    },
  },
  watch: {
    timerCount: {
      handler(value) {
        if (value > 0) {
          setTimeout(() => {
            this.timerCount--;
          }, 1000);
        }
      },
      immediate: true, // This ensures the watcher is triggered upon creation
    },
  },
};
</script>
